/**
* @license Apache-2.0
*
* Copyright (c) 2025 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

import isDataView from '@stdlib/assert-is-dataview';
import isObject from '@stdlib/assert-is-object';
import PRIVATE_BUFFER from './private_buffer.js';


// MAIN //

/**
* Returns a boolean indicating if a value is a `struct` instance.
*
* @private
* @param {*} value - value to test
* @returns {boolean} boolean indicating if a value is a `struct` instance
*/
function isStructInstance( value ) {
	// NOTE: the following is a relatively weak test, but we cannot use `instanceof` checks, etc, due to the factory nature of the implementation. Regardless, here, we are just trying to sniff out a `struct` type. If calling as a constructor later fails, we punt the responsibility off to the user to handle what should be an edge case. If, in the future, this check proves insufficient, we can add further "brand" checks...
	return (
		isObject( value ) &&
		isDataView( value[ PRIVATE_BUFFER ] )
	);
}


// EXPORTS //

export default isStructInstance;
